import React from "react";
import { motion } from "framer-motion";
import { PROCESS } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { Search, ClipboardList, FileText, Boxes, Hammer, PaintRoller, TestTube, ShieldCheck } from "lucide-react";

const icons = [Search, ClipboardList, FileText, Boxes, Hammer, PaintRoller, TestTube, ShieldCheck];

export default function ProcessTimeline() {
  return (
    <section className="bg-navy-deep py-24 md:py-32 relative overflow-hidden grain" data-testid="process">
      <div className="max-w-6xl mx-auto px-5 md:px-8 relative z-10">
        <Reveal>
          <div className="text-center mb-16">
            <span className="text-sky text-xs font-semibold tracking-[0.3em] uppercase">How We Work</span>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold text-white mt-3">Our 8-Step Engineering Process</h2>
          </div>
        </Reveal>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-sky/60 via-royal/40 to-transparent" />
          <div className="space-y-8">
            {PROCESS.map((p, i) => {
              const Icon = icons[i];
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, x: left ? -40 : 40 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                  className={`relative flex items-center gap-6 md:w-1/2 ${left ? "md:pr-12" : "md:ml-auto md:pl-12 md:flex-row-reverse md:text-right"}`}
                >
                  <div className="absolute left-4 md:left-auto md:right-0 md:translate-x-1/2 -translate-x-1/2 h-8 w-8 rounded-full bg-royal border-4 border-navy-deep flex items-center justify-center z-10"
                    style={left ? { right: "-1rem" } : { left: "-1rem" }}>
                    <span className="text-white text-xs font-bold">{i + 1}</span>
                  </div>
                  <div className="glass-dark rounded-lg p-5 ml-10 md:ml-0 flex-1">
                    <div className={`flex items-center gap-3 ${!left ? "md:flex-row-reverse" : ""}`}>
                      <div className="h-10 w-10 rounded-md bg-royal/20 flex items-center justify-center shrink-0"><Icon className="h-5 w-5 text-sky" /></div>
                      <h3 className="font-display text-lg font-bold text-white">{p.title}</h3>
                    </div>
                    <p className="text-slate-300 text-sm mt-2">{p.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
